"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function useScroll(_a) {
    var _b = _a === void 0 ? {} : _a, paddingSelector = _b.paddingSelector;
    var disableScroll = function () {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        window.onscroll = function () {
            window.scrollTo(scrollLeft, scrollTop);
        };
        var scrollBarWidth = window.innerWidth - document.body.offsetWidth;
        document.body.style.overflow = "hidden";
        document.body.style.paddingRight = "".concat(scrollBarWidth, "px");
        if (paddingSelector) {
            var els = document.querySelectorAll(paddingSelector);
            if (els) {
                els.forEach(function (el) {
                    el.style.paddingRight = "".concat(scrollBarWidth, "px");
                });
            }
        }
    };
    var enableScroll = function () {
        window.onscroll = null;
        document.body.style.removeProperty("overflow");
        document.body.style.removeProperty("padding-right");
        if (paddingSelector) {
            var els = document.querySelectorAll(paddingSelector);
            if (els) {
                els.forEach(function (el) {
                    el.style.removeProperty("padding-right");
                });
            }
        }
    };
    return {
        disableScroll: disableScroll,
        enableScroll: enableScroll,
    };
}
exports.default = useScroll;
//# sourceMappingURL=index.js.map